import React, { useState, useEffect, Fragment } from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import {
    AppBar,
    Box,
    Button,
    Container,
    Grid,
    IconButton,
    List,
    ListItem,
    Paper,
    Toolbar,
    Typography,
} from '@material-ui/core';

import {
    member as v_member,
    basic,
    order as v_order,
    Values,
    SNACKBAR_TIME,
    FINISH_TIME,
} from '../request/values';

import axios from 'axios';

import { COLORS } from './Theme';

import DialogConfirm, {
    DialogCompanyApproval,
    DialogSaleApproval,
} from './Dialog';
import { useHistory, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';
import { TitleBackBar } from './header/TitleBar';
import { DateRange, SlowMotionVideoTwoTone } from '@material-ui/icons';

const SERVER = basic.server;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: 0,
            height: '88vh',
            width: '95vw',
            paddingTop: '1.5vh',
            background: `${COLORS.WHITE}`,
        },
        materialItem: {
            borderRadius: 12,
            margin: 'auto',
            marginBottom: '1.5vh',

            boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
            width: '82vw',
            paddingTop: '2.2vh',
            paddingBottom: '2.2vh',
        },

        list: {
            width: '95vw',
            height: '76vh',
            overflowY: 'auto',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            fontSize: '4vw',
            color: `${COLORS.BROWNISH_GREY}`,
        },
        materialImage: {
            textAlign: 'center',
            margin: 'auto',
            '& img': {
                width: '11vw',
            },
        },

        materialDesc: {
            textAlign: 'left',
            paddingLeft: '1vw',
            '& #materialName': {
                fontSize: '3.5vw',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
            },
            '& #materialSubName': {
                fontSize: '3vw',
                color: `${COLORS.BROWNISH_GREY}`,
            },
        },
        buttonSection: {
            marginTop: '3vw',
            height: '6vh',
            textAlign: 'center',
        },
        button: {
            width: '39vw',
            height: '6vh',
            fontSize: 18,
            fontFamily: 'NanumB',

            borderRadius: '12px',
            boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',

            '& #accept': {
                color: `${COLORS.WATER_BLUE}`,
            },
            '& #refuse': {
                color: `${COLORS.PUMPKIN}`,
            },
            // border: 'solid 0.5px #cfd4d9',
        },

        postLoanButton: {
            borderRadius: '8.5px',
            fontSize: '3.2vw',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            marginTop: '2vh',
        },
    })
);

type iMaterial = {
    materialImage: string;
    materialName: string;
    materialSubName: string;
    materialCode: string;
    materialCount: number;
    materialLoanStatus: string;
};

const MaterialLoanSheet: React.FC<any> = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [materialSale, setMaterialSale] = useState<iMaterial[]>([]);
    const [loanStatus, setLoanStatus] = useState([]);

    const [confirm, setConfirm] = useState<number>(0);
    const [item, setItem] = useState<number>(0);
    const { member } = props;

    const state: any = history.location.state;
    const loan = state.loan;

    const getMaterialLoanSheetList = () => {
        let url = new URL(
            basic.server + v_member.member + v_member.material_loan_sheet
        );
        let param = { loanNum: loan.loanNum };
        url.search = new URLSearchParams(param).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data) => {
                console.log(data);
                if (data.code === Values.SUCCESS_CODE) {
                    if (data.materials === null) {
                        enqueueSnackbar(
                            ToastStr.MATERIAL_SHEET_LIST_EMPTY_STR,
                            {
                                variant: 'warning',
                                autoHideDuration: SNACKBAR_TIME,
                                translate: 'no',
                            }
                        );
                    } else if (data.materials.length === 0) {
                        enqueueSnackbar(
                            ToastStr.MATERIAL_SHEET_LIST_EMPTY_STR,
                            {
                                variant: 'warning',
                                autoHideDuration: SNACKBAR_TIME,
                                translate: 'no',
                            }
                        );
                    } else {
                        setMaterialSale((prevState) => data.materials);
                    }
                } else if (data.code === Values.FAIL_CODE) {
                    enqueueSnackbar(
                        ToastStr.MATERIAL_SHEET_LIST_DUPLICATE_STR,
                        {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        }
                    );
                }
            });
    };

    const postLoanUpdate = (index: any) => {
        axios({
            method: 'POST',
            data: {
                companyNum: member.companyNum,
                materialCode: materialSale[index].materialCode,
                loanNum: loan.loanNum,
                classCode: member.classCode,
            },
            withCredentials: true,
            url: SERVER + v_member.member + v_member.material_payback,
        })
            .then((res) => {
                return res.data;
            })
            .then((data: any) => {
                console.log(data);
                if (data.code === Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.MATERIAL_PAYBACK_APPROVAL_STR, {
                        variant: 'success',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                    getMaterialLoanSheetList();
                } else if (data.code === Values.FAIL_CODE) {
                    enqueueSnackbar(ToastStr.MATERIAL_PAYBACK_FAIL_STR, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                }
            });
    };

    useEffect(() => {
        getMaterialLoanSheetList();
    }, []);

    return (
        <Container
            component="main"
            className={classes.container}
            translate="no"
        >
            <TitleBackBar
                history={history}
                title="대출명세서"
                titleIcon="order"
            />

            <Box display="flex" justifyContent="center" alignItems="center">
                <List className={classes.list}>
                    {materialSale != null &&
                        materialSale.map((item: any, index: number) => {
                            return (
                                <ListItem
                                    className={classes.materialItem}
                                    alignItems="center"
                                >
                                    <MaterialSaleItem
                                        item={item}
                                        //postLoanUpdate={(e: any) => { postLoanUpdate(index) }}
                                        companyNum={member.companyNum}
                                        loanNum={loan.loanNum}
                                        classCode={member.classCode}
                                        getSheetList={getMaterialLoanSheetList}
                                    />
                                </ListItem>
                            );
                        })}
                </List>
            </Box>
        </Container>
    );
};

const MaterialSaleItem: React.FC<any> = (props) => {
    const { item, companyNum, loanNum, classCode, getSheetList } = props;

    const classes = useStyles();
    const [dialogState, setDialogState] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const handleClose = () => {
        setDialogState(false);
    };

    const handleOpen = () => {
        console.log('in handleOpen');
        if (!dialogState) {
            setDialogState(true);
        }
    };

    const postLoanUpdate = (index: any) => {
        axios({
            method: 'POST',
            data: {
                companyNum: companyNum,
                materialCode: item.materialCode,
                loanNum: loanNum,
                classCode: classCode,
            },
            withCredentials: true,
            url: SERVER + v_member.member + v_member.material_payback,
        })
            .then((res) => {
                return res.data;
            })
            .then((data: any) => {
                console.log(data);
                if (data.code === Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.MATERIAL_PAYBACK_APPROVAL_STR, {
                        variant: 'success',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                    getSheetList();
                } else if (data.code === Values.CLASS_STOCK_INSUFFICIENT_CODE) {
                    enqueueSnackbar(ToastStr.MATERIAL_STOCK_INSUFFICIENT_STR, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else if (data.code === Values.FAIL_CODE) {
                    enqueueSnackbar(ToastStr.MATERIAL_PAYBACK_FAIL_STR, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                }
            });
        handleClose();
    };

    return (
        <Grid container justify={'center'} alignContent="center" translate="no">
            <Grid xs={2} className={classes.materialImage}>
                <img
                    src={
                        basic.server +
                        '/displayImage?fileName=' +
                        item.materialImage
                    }
                />
            </Grid>
            <Grid xs={7} style={{ margin: 'auto' }}>
                <Grid
                    container
                    className={classes.materialDesc}
                    direction="column"
                >
                    <Grid id="materialName">{item.materialName}</Grid>
                    <Grid id="materialSubName">
                        {item.materialSubName} {item.materialCode}
                    </Grid>
                </Grid>
            </Grid>
            <Grid xs={3}>
                <div style={{ textAlign: 'end' }}>
                    <Typography
                        display="inline"
                        variant="h1"
                        style={{
                            color: `${COLORS.BROWNISH_GREY}`,
                            fontWeight: 'bold',
                        }}
                    >
                        개수{' '}
                    </Typography>
                    <Typography
                        display="inline"
                        variant="h3"
                        style={{
                            color: `${COLORS.WATER_BLUE}`,
                            fontWeight: 'bold',
                        }}
                    >
                        {`${item.materialCount} `}
                    </Typography>
                </div>
                <div style={{ textAlign: 'end' }}>
                    <div className={classes.postLoanButton}>
                        {item.materialLoanStatus === 'complete' ? (
                            <Button
                                disabled
                                style={{
                                    backgroundColor: `${COLORS.LIGHT_BLUE_GREY}`,
                                    color: `${COLORS.WHITE}`,
                                }}
                            >
                                상환완료
                            </Button>
                        ) : (
                            <Button
                                onClick={handleOpen}
                                style={{
                                    backgroundColor: `${COLORS.WATER_BLUE}`,
                                    color: `${COLORS.WHITE}`,
                                }}
                            >
                                상환하기
                            </Button>
                        )}
                    </div>
                </div>
                <DialogConfirm
                    open={dialogState}
                    handleClose={handleClose}
                    title={'해당 재료를 상환하시겠습니까?'}
                    context={item.materialName}
                    yesText="네"
                    noText="아니오"
                    noConfirm={handleClose}
                    yesConfirm={postLoanUpdate}
                />
            </Grid>
        </Grid>
    );
};

export default MaterialLoanSheet;
